'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VResponsive = undefined;

var _VResponsive = require('./VResponsive');

var _VResponsive2 = _interopRequireDefault(_VResponsive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.VResponsive = _VResponsive2.default;
exports.default = _VResponsive2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VResponsive/index.js
// module id = 523
// module chunks = 0